import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import { GetPaymentResultDTO } from '@src/api/@types/GetPaymentResultDTO'
import { TablePayment } from '@src/components'
import { formatDateWithoutDay } from '@src/services/Formatter'
import { FC } from 'react'

interface Props {
  payments?: GetPaymentResultDTO[]
  activeIndex: number | null
  toggleAccordion: (index: number) => void
}

const LastPayments: FC<Props> = ({ payments, activeIndex, toggleAccordion }) => {
  return (
    payments?.map((payment, index) => (  
      <Accordion
        key={payment.id}
        expanded={activeIndex === index}
        onChange={() => toggleAccordion(index)}
        sx={{
          marginBottom: '5px',
          boxShadow: 'none',
          width: { xs: '100%', sm: '80%', md: '75%', lg: '100%', xl: '100%' },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls={`panel${index}-content`}
          id={`panel${index}-header`}
          sx={{
            backgroundColor: '#101010',
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ width: '100%', textAlign: 'left', fontSize: '13px' }}>
            {formatDateWithoutDay(payment.plannedOnDateUTC)}
          </Typography>
          <Typography sx={{ position: 'absolute', right: 25, fontSize: '13px', mr: 5 }}>
            ${payment.amount.toFixed(2)}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#101010', overflowX: 'auto' }}>
          <TablePayment payment={payment} />
        </AccordionDetails>
      </Accordion>
    )) ?? null
  )
}

export default LastPayments
